<template>
  <section class="container row content-padding">
    <div class="col-md-3 sidenav-column">
      <ul class="list-unstyled">
        <li>
          <router-link to="/my-reservations"
                       active-class="sidenav-active"
                       class="sidenav-item">
            {{ $t('message.menu.my_reservations') }}
          </router-link>
        </li>
      </ul>
      <router-link to="/booking/start" class="button button-large -cyan">
        {{ $t('message.my_reservations.new_booking') }}
      </router-link>
      <p>&nbsp;</p>
    </div>
    <div class="col-md-9 content-column">
      <transition name="slide" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </section>
</template>

<script>
  export default {
    mounted () {
      this.$store.commit('order/SET_CURRENT_ORDER_TYPE', null)
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/order/Index.vue